export default __webpack_public_path__ + "static/media/Google.4a1a4e63.png";